// Module
var code = "<administration-accounts-employees-grid title=\"$ctrl.title\"></administration-accounts-employees-grid>\n\n<tabs-navigation identifier=\"app.administration.accounts.departments\"\n                 state=\"app.administration.accounts.departments.employees\">\n</tabs-navigation>\n";
// Exports
module.exports = code;